export const CONCEALED_REPORT_NAME = 'Concealed user';

export const loadReportNameConcealment = async (tenantId?: string): Promise<boolean> => {
  const params = new URLSearchParams();
  if (tenantId) params.set('tenantId', tenantId);
  const response = await fetch(`/api/report-name-concealment${params.size ? `?${params.toString()}` : ''}`);
  if (!response.ok) {
    throw new Error(`Report privacy could not be loaded (${response.status}).`);
  }
  const payload = await response.json() as { active?: boolean; concealNames?: boolean };
  return payload.active === true && payload.concealNames === true;
};
